export default __webpack_public_path__ + "7725eba0f1d51694fdce87a5a6d359c7.svg";